import { Component, OnInit } from '@angular/core';
import { LanguageService } from '../../../angular-wallet-base/services/language.service';
import { Subscription } from 'rxjs';
import { Store } from '@ngrx/store';
import { AppState } from '../../../angular-wallet-base/store/appState';
import { getBaseCurrency } from '../../../angular-wallet-base/store/userPreferences';
import { SetBaseCurrencyAction } from '../../../angular-wallet-base/actions/userPreferences.actions';
import { CoinGeckoService } from '../../../angular-wallet-base/services/coingecko.service';
import { MembersPortalService } from '../../../angular-wallet-base/services/members-portal.service';
import { TranslateService } from '@ngx-translate/core';
import { AppModeService } from 'src/app/angular-wallet-base/services/app-mode.service';
import { getSideMenuStatus } from 'src/app/angular-wallet-base/store/appSettings';
import { take } from 'rxjs/operators';
import { AlertController, ModalController, Platform } from '@ionic/angular';
import { SelectReceivingAddressComponent } from './select-receiving-address/select-receiving-address.component';
import { Clipboard } from '@ionic-native/clipboard/ngx';
import { MicroRewardService } from 'src/app/angular-wallet-base/services/micro-reward.service';
import { Logger } from 'src/app/angular-wallet-base/services/logger.service';
import { handleCopy } from 'src/app/angular-wallet-base/utils';
import { ClipboardService } from 'ngx-clipboard';
import { SubscriptionListenerComponent } from 'src/app/angular-wallet-base/SubscriptionListenerComponent';
import { StorageService } from 'src/app/angular-wallet-base/services/storage.service';
import { WALLET_STORAGE_KEY } from 'src/app/angular-wallet-base/constants';

interface AssociatedAddress {
  id: number;
  lodeid: number;
  address_type: string;
  is_primary: boolean;
  address: string;
}

@Component({
  selector: 'app-preference',
  templateUrl: './preference.component.html',
  styleUrls: ['./preference.component.scss'],
})
export class PreferenceComponent extends SubscriptionListenerComponent implements OnInit {
  public supportedLanguagesList = [];
  public currentBaseCurrency: string;
  protected subscriptions = new Subscription();
  public currentLanguage = {};
  public currencyListDesktop = [];
  public news = { isTitle1Checked: false, isTitle2Checked: false, };
  public lodeUser;
  public isDesktopMode: boolean;
  public loadingSpinner: boolean;
  public isPrimaryAddressSet: boolean = false;
  public primaryAddressMsg: string;
  public primaryAddressBtnText: string;
  public associateAddressOfUser: AssociatedAddress;
  public loader = false;
  public showWalletInfo: boolean = false;

  constructor(
    private languageService: LanguageService,
    protected store: Store<AppState>,
    private coinGecko: CoinGeckoService,
    private membersPortalService: MembersPortalService,
    private modalController: ModalController,
    public appMode: AppModeService,
    public microRewardService: MicroRewardService,
    public platform: Platform,
    public alertController: AlertController,
    public translate: TranslateService,
    public clipBoard: Clipboard,
    public clipBoardService: ClipboardService,
    private storage: StorageService,
  ) {
    super(store);
    this.appMode.isDesktopMode.subscribe(mode => this.isDesktopMode = mode);
    this.coinGecko.getSupportedBaseCurrencies().then((currencies: string[]) => {
      this.currencyListDesktop = currencies.map(item => ({
        value: item, viewValue: item.toUpperCase()
      }));
    });
  }

  async ngOnInit() {
    this.loadingSpinner = true;
    // check wallet info
    this.showWalletInfo = (await this.storage.get(WALLET_STORAGE_KEY)) ? true : false;
    this.loadingSpinner = false;
    this.loader = true;
    this.lodeUser = await this.membersPortalService.getUserInfo();
    this.news.isTitle1Checked = Boolean(this.lodeUser.list_newsletter);
    this.news.isTitle2Checked = Boolean(this.lodeUser.list_announce);
    const languagesList = this.languageService.getLanguages();
    this.supportedLanguagesList = this.mapLanguageListToDropdown(languagesList);
    const language = this.languageService.getCurrentLanguage();
    this.currentLanguage = await this.mapLanguageListToDropdown(language)[0];
    this.subscriptions.add(this.store.select(getBaseCurrency).subscribe(async baseCurrency => this.currentBaseCurrency = await baseCurrency));
    this.loader = false;
    this.subscriptions.add(this.microRewardService.isSuccess.subscribe(async res => {
    }));
  }

  async checkUsersAssociateAddress() {

    const address = await this.microRewardService.getAssociateAddressOfUser();
    if (address && address.associated_addresses && address.associated_addresses.length > 0) {
      this.associateAddressOfUser = address.associated_addresses.find((address: { is_primary: boolean; }) => address.is_primary);
      Logger.info('associateAddressOfUser', this.associateAddressOfUser);
      this.isPrimaryAddressSet = this.associateAddressOfUser ? true : false;
    }
    if (!this.isPrimaryAddressSet) {
      this.primaryAddressMsg = 'no_primary_address.no_primary_address_msg';
      this.primaryAddressBtnText = 'no_primary_address.set_primary_btn';
    } else {
      this.primaryAddressMsg = 'primary_address_set.primary_address_msg';
      this.primaryAddressBtnText = 'primary_address_set.change_primary_address_btn';
    }
  }

  async handleNotificationsUpdate(section: any) {
    switch (section) {
      case 'news':
        const newsUpdate = this.news.isTitle1Checked ? '1' : '0';
        try {
          await this.membersPortalService.updateNewsletterList((newsUpdate));
        } catch (err) {
          this.news.isTitle1Checked = !this.news.isTitle1Checked;
        }
        break;
      case 'announce':
        const announceUpdate = this.news.isTitle2Checked ? '1' : '0';
        try {
          await this.membersPortalService.updateAnnounceList((announceUpdate));
        } catch (err) {
          this.news.isTitle2Checked = !this.news.isTitle2Checked;
        }
        break;
      default:
        break;
    }
  }
  mapLanguageListToDropdown(languagesList) {
    return languagesList.map(item => ({
      value: item.value, viewValue: item.text
    }));
  }
  handleCurrencyChangeDesktop(val) {
    this.store.dispatch(new SetBaseCurrencyAction({ baseCurrency: val.toUpperCase() }));
  }
  
  handleLanguageChange(val) {
    this.languageService.setLanguage(val);
    this.membersPortalService.updateUserLanguage(val);
    const language = this.languageService.getCurrentLanguage();
    this.currentLanguage = this.mapLanguageListToDropdown(language)[0];
  }

  // Micro reward related functions

  async openSelectAddressModal() {
    let cssClass = '';
    const sideMenuHidden = await this.store.select(getSideMenuStatus).pipe(take(1)).toPromise();
    cssClass += (this.isDesktopMode) ? 'primary-address-success-modal-desktop' : 'primary-address-success-modal';
    cssClass += (!sideMenuHidden && this.isDesktopMode) ? ' with-side-menu' : '';
    const modal = await this.modalController.create({
      component: SelectReceivingAddressComponent,
      cssClass,
      initialBreakpoint: (this.isDesktopMode) ? undefined : 0.6,
      breakpoints: (this.isDesktopMode) ? undefined : [0, 0.4, 0.5, 0.6, 1],
      id: 'selectAddressModal'
    });
    await modal.present();
  }

  doCopy() {
    const message = this.associateAddressOfUser?.address;
    handleCopy(message, this.platform, this.clipBoard, this.alertController, this.translate, this.clipBoardService, null);
  }
}
